module.exports = __webpack_public_path__ + "static/media/verbs_in_ui4.b55f8d83.JPG";